module.exports = __webpack_public_path__ + "static/media/control_de_carga2.dab72f92.svg";